import { loginRequest, msalInstance } from "config/msalConfig";
import jwtDecode from "jwt-decode";

export async function getEmail(): Promise<string | undefined> {
	const token = await msalInstance.acquireTokenSilent(loginRequest).catch(console.warn);
	return token ? jwtDecode<{ email?: string }>(token.idToken)?.email?.toLowerCase() || "" : "";
}
